import { reset } from './reset.js';
import { typography } from './typography.js';

export const styles = [
  reset,
  ...typography
]